<template>
  <div>
    <div
      v-if="isLogged"
      class="h-screen flex w-full bg-img vx-row no-gutter items-center justify-center"
      id="management"
      v-bind:style="{ 'background-image': 'url(' + imagenFondo + ') !important',
      'background-attachment': 'fixed',
      overflow: 'scroll'
    }"
    >
      <img
        v-if="ingresoLogo"
        :src="ingresoLogo.imagen"
        id="logo"
        v-bind:style="logoStyle"
        alt="logo"
      />
      <b-card class="bg-card-grey" v-if="fileOnFlow.ejecucion">
        <div class="row">
          <div class="col-1 position-relative text-center">
            <div v-if="fileOnFlow.documentos.length" class="container-attachment">
              <div
                class="box-attachments"
                v-for="attachment in fileOnFlow.documentos"
                :key="attachment.adjuntoUrl"
              >
                <b-button
                  variant="outline-warning"
                  class="btn-icon mt-2 text-center shadow"
                  @click="selectFile(attachment)"
                  data-cy="attachment"
                >
                  <feather-icon icon="FileTextIcon" />
                </b-button>
              </div>
              <div
                class="position-fixed manage-comments text-left m-auto"
                v-if="isAvailableSign && !signed"
              >
                <h6 style="font-size: 12px;" class="my-2">
                  Hey, estampa!!
                </h6>
                <b-button
                  ref="signPosition"
                  variant="warning"
                  class="btn-icon rounded-circle shadow-lg sign-file"
                  @click="setSign"
                  data-cy="stamp"
                >
                  <feather-icon icon="FeatherIcon" />
                </b-button>
              </div>
            </div>
          </div>
          <div class="col-7">
            <a
              :href="selectedFile.adjuntoUrl"
              v-if="selectedFile"
              target="_blank"
            >
              <h5
                class="text-primary underline d-inline-block mr-2"
                data-cy="document-viewer"
              >
                * Visualizando documento seleccionado {{selectedFile.objetoNombre}}
                <small>({{selectedFile.objetoNombre}})</small> *
              </h5>
              <feather-icon icon="ExternalLinkIcon" />
            </a>
            <div v-if="selectedFile" class="shadow bg-gray">
              <div v-if="fileType === 'pdf'" class="d-flex">
                <PdfViewport
                  ref="pdfSignaturePerson"
                  :s3url="selectedFile.adjuntoUrl"
                  :name="selectedFile.objetoNombre"
                  :signatures="signatures"
                  :signature-height="signatureHeight"
                  :signature-width="signatureWidth"
                  @signature-drag-end="onSignatureDragEnd"
                  @loaded="setSign"
                  @signature-delete="closeSign"
                  :closable="false"
                />
              </div>
              <div v-if="fileType === 'image'">
                <b-img :src="selectedFile.adjuntoUrl" fluid :alt="selectedFile.objetoNombre" />
              </div>
            </div>
          </div>
          <div class="col-4">
            <b-card class="shadow border-1 pt-0">
              <div class="bg-white pb-2">
                <h5 class="card-title mb-0" v-if="fileOnFlow.ejecucion">
                  Expediente # {{fileOnFlow.ejecucion.numero}} en el
                  {{fileOnFlow.ejecucion.nombre}}
                </h5>
                <div class="text-primary">
                  {{fileOnFlow.ejecucion.descripcion}}
                </div>
              </div>
              <b-card-body class="p-0">
                <div class="mt-5" v-if="isAvailableSign && !signed">
                  <b-overlay :show="signing">
                    <b-button
                      v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                      variant="outline-success"
                      data-cy="sign"
                      block
                      @click="confirmSignFile()"
                    >
                      Firmar
                    </b-button>
                  </b-overlay>
                </div>
              </b-card-body>
            </b-card>
          </div>
        </div>
      </b-card>
    </div>
    <OtpModalExternal
      ref="otpModal"
      @submit="onOtpSubmit"
      @cancel="onOtpCancel"
    />
  </div>
</template>
<script>
import OtpModalExternal from "@/febos/chile/approvals/components/OtpModalExternal";
import { mapActions, mapGetters } from 'vuex';
import { uuid } from 'vue-uuid';

import PersonalizacionMixin from '@/febos/global/empresas/mixins/PersonalizacionMixin';
import PdfViewport from '@/febos/global/pdf/components/PdfViewport';
import Steps from '@/febos/chile/approvals/components/trays/managementTray/informationFlow/Steps';
import { SIGNATURE_TYPES } from '@/febos/global/pdf/config';
import ApprovalProcessStates from '@/febos/chile/approvals/mixins/ApprovalProcessStates';
import AvanzadaSignEsign7External from "@/febos/global/usuario/components/sign/advanced/eSign/AvanzadaSignEsign7External";
import {cuEsignCertifiedExternal, setSignIdExternal} from "@/febos/servicios/api/v2.aprobaciones.api";
import {getApprovalFileSignatureExternal} from "@/febos/chile/approvals/store/moduloApprovalsActions";

const SIGNATURE_WIDTH = 150;
const SIGNATURE_HEIGHT = 50;

export default {
  mixins: [PersonalizacionMixin],
  components: {
    OtpModalExternal,
    AvanzadaSignEsign7External,
    PdfViewport,
    Steps
  },
  data() {
    const isLogged = this.$route.query.idProceso;

    return {
      signing: false,
      signed: false,
      isLogged: isLogged,
      isAuthorized: false,
      signatures: [{ x: 198, y: 119 }],
      selectedFile: undefined,
      fileType: undefined,
      showSignButton: false,
      signatureWidth: SIGNATURE_WIDTH,
      signatureHeight: SIGNATURE_HEIGHT,
      flowStates: ApprovalProcessStates,
      signToken: null,
      documentIdSign: null,
      signName: null,
      isSignApi: false,
      otpCode: null,
    };
  },
  watch: {
    loading(value) {
      if (!value) {
        this.$vs.loading.close('#management > .con-vs-loading');
        return;
      }

      this.$vs.loading({
        container: '#management',
        scale: 0.6
      });
    }
  },
  computed: {
    ...mapGetters('Personalizacion', [
      'colors',
      'empresaPortal'
    ]),
    ...mapGetters('Approvals', [
      'loading',
      'fileOnFlow'
    ]),
    token() {
      const { token } = this.$route.params;
      return token;
    },
    currentStep() {
      const {
        pasoEjecucion
      } = this.fileOnFlow;
      return pasoEjecucion;
    },
    hasSignaturePosition() {
      return (
        this.currentStep.x
        && this.currentStep.y
        && this.currentStep.pagina
      );
    },
    stepsFile() {
      return [this.fileOnFlow.ejecucion.pasoActual];
    },
    isAvailableSign() {
      return this.fileOnFlow.pasoEjecucion.aprobacionesPasoEstadoId === this.flowStates.PROCESSING
        || this.fileOnFlow.pasoEjecucion.aprobacionesPasoEstadoId.toString() === this.flowStates.PROCESSING;
    }
  },
  methods: {
    ...mapActions('Approvals', [
      'getApprovalFileSignatureExternal',
      'singPersonFile',
      'getCUInfo'
    ]),
    selectFile(file) {
      this.signatures = [];
      this.selectedFile = undefined;
      this.fileType = undefined;

      const fileName = file.objetoNombre.toLowerCase();

      if (file && (fileName.includes('png')
        || fileName.includes('jpg')
        || fileName.includes('jpeg')
      )) {
        this.fileType = 'image';
        this.selectedFile = file;
      }

      if (file && fileName.includes('pdf')) {
        this.fileType = 'pdf';
        this.selectedFile = file;

        this.showSignButton = !file.objetoId;
        return;
      }

      this.$bvToast.toast(
        'Este tipo de archivo no puede ser visualizado',
        {
          title: '¡Oops!',
          variant: 'warning',
          pauseOnHover: true,
          solid: true,
          noAutoHide: true
        }
      );
      window.open(file.url, '_blank');
    },
    onSignatureDragEnd({ x, y }, signatureDraged) {
      const [signature] = this.signatures.filter(
        (signatureItem) => signatureItem.signatureId === signatureDraged.signatureId
      );
      this.signatures = [
        {
          ...signature,
          x,
          y
        }, ...this.signatures.filter(
          (signatureItem) => signatureItem.signatureId !== signatureDraged.signatureId
        )
      ];
    },
    setSign() {
      if (!this.isAvailableSign || this.signed) {
        this.signatures = [];
        return;
      }
      if (this.hasSignaturePosition) {
        const {
          x,
          y,
          pagina: page
        } = this.currentStep;
        const { paso } = this.fileOnFlow;
        const signatureId = uuid.v4();
        this.signatures = [{
          id: signatureId,
          x,
          y,
          page,
          type: SIGNATURE_TYPES.PersonSignature,
          name: paso.responsable
        }];
      } else {
        const pageNumber = this.$refs.pdfSignaturePerson.getPageNumber();
        const pageHeight = this.$refs.pdfSignaturePerson.getPageHeight();
        const signatureId = uuid.v4();
        this.signatures = [{
          signatureId,
          x: 20,
          y: pageHeight - 70,
          page: pageNumber,
          type: SIGNATURE_TYPES.DraggableUserSignature
        }];
      }
    },
    closeSign() {
      this.signatures = [];
    },
    confirmSignFile() {
      this.$vs.dialog({
        type: 'confirm',
        color: 'primary',
        title: 'Heey!',
        text: '¿Estás seguro de firmar este documento?',
        cancelText: 'Cancelar',
        acceptText: 'Confirmar',
        accept: () => this.signFile()
      });
    },
    async signFile() {
      try {
        this.signing = true;
        const idProceso = this.$route.query.idProceso;

        const response = await setSignIdExternal({
          processId: idProceso,
          token: this.token,
          signToken: this.signToken,
          OTP: this.otpCode,
          documentId: this.documentIdSign,
          signName: this.signName
        });

        // Si retorna signToken → es primera llamada SignApi, pedir OTP
        const meta = response.data && response.data.meta ? response.data.meta : response.data;
        if (meta && meta.signToken && !this.signToken) {
          this.signToken = meta.signToken;
          this.documentIdSign = meta.documentId;
          this.signName = meta.signName || null;
          this.signing = false;
          this.$refs.otpModal.show();
          return;
        }

        this.signing = false;
        this.signed = true;
        this.$bvToast.toast(
          'Se ha firmado exitosamente el documento',
          {
            title: '¡Genial!',
            variant: 'primary',
            pauseOnHover: true,
            solid: true,
            noAutoHide: true
          }
        );
        await this.reloadAfterSign();
      } catch (error) {
        this.signing = false;
        this.$bvToast.toast(
          error.response?.data?.errores?.[0] || 'Error al firmar',
          {
            title: 'Error',
            variant: 'danger',
            solid: true,
            noAutoHide: true
          }
        );
      }
    },
    async onOtpSubmit(otpCode) {
      this.otpCode = otpCode;
      this.$refs.otpModal.setLoading(true);

      const idProceso = this.$route.query.idProceso;
      try {
        await setSignIdExternal({
          processId: idProceso,
          token: this.token,
          signToken: this.signToken,
          OTP: otpCode,
          documentId: this.documentIdSign,
          signName: this.signName
        });

        this.$refs.otpModal.setLoading(false);
        this.$refs.otpModal.hide();
        this.signed = true;
        this.$bvToast.toast(
          'Se ha firmado exitosamente el documento',
          {
            title: '¡Genial!',
            variant: 'primary',
            pauseOnHover: true,
            solid: true,
            noAutoHide: true
          }
        );
        await this.reloadAfterSign();
      } catch (error) {
        this.$refs.otpModal.setLoading(false);
        this.$bvToast.toast(
          error.response?.data?.errores?.[0] || 'Código OTP inválido',
          {
            title: 'Error',
            variant: 'danger',
            solid: true,
          }
        );
      }
    },
    onOtpCancel() {
      this.signToken = null;
      this.documentIdSign = null;
      this.signName = null;
    },
    async reloadAfterSign() {
      // Igual que firma-persona: limpia la estampa, recarga el expediente
      // y reselecciona el documento para refrescar el PDF firmado.
      this.signatures = [];
      try {
        await this.getApprovalFileSignatureExternal({ token: this.token });
        if (this.fileOnFlow.documentos && this.fileOnFlow.documentos.length) {
          this.selectFile(this.fileOnFlow.documentos[0]);
        }
      } catch (error) {
        console.error(error);
      }
    }
  },
  async created() {
    try {
      this.isSignApi = this.$route.query.provider === 'signapi';
      this.$bvToast.toast(
        'Estamos buscando la información necesaria, espera unos segundos',
        {
          title: '¡Hola!',
          variant: 'primary',
          pauseOnHover: true,
          solid: true,
          autoHideDelay: 4000
        }
      );
      const payload = {
        token: this.token
      };
      console.log('PEPEPEPE', this.fileOnFlow);
      await this.getApprovalFileSignatureExternal(payload);
      this.selectFile(this.fileOnFlow.documentos[0]);
    } catch (error) {
      console.error(error);
    }
  }
};
</script>

<style lang="scss">

.container-attachment {
  max-height: 55vh;
  overflow-y: scroll;
}
.manage-comments {
  bottom: 60px;
}
.bg-card-grey {
  background-color: #f8f8f8;
  margin-top: 120px;
  min-height: 80%;
  min-width: 85%;
}
</style>
